import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import * as ContactUsPageActions from '../action/contactUs-page.action';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
@Injectable()
export class ContactUsPageEffects {
  protected logger = inject(LoggerService);

  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private globalService: GlobalService,
  ) { }


  // contactusdetails$ = createEffect(() =>
  //   this.actions.pipe(
  //     ofType(ContactUsPageActions.submitForm),
  //     switchMap((action) => {
  //       this.globalService.loadingSubject.next(true)
  //       const formData = new FormData();
  //   formData.append('basesiteId', action.formData?.basesiteId);
  //   formData.append('subject', action.formData?.subject);
  //   formData.append('email', action.formData.email);
  //   formData.append('message', action.formData.message);
  //   formData.append('document', action.formData?.document);
  //       return this.apiService.contactusdetails(formData).pipe(
  //         map((response) => {
  //           this.globalService.loadingSubject.next(false)
  //           if (response.status == 201) {
  //             // this.globalService.loadingSubject.next(false)
  //           }
  //           return ContactUsPageActions.submitFormSuccess();
  //         }),
  //         catchError((error) => {
  //           this.globalService.loadingSubject.next(false)
  //           return of(ContactUsPageActions.submitFormFail({ payload: tryNormalizeHttpError(error, this.logger) }));
  //         })
  //       );
  //     })
  //   )
  // );

  contactusdetails$: Observable<
    ReturnType<typeof ContactUsPageActions.submitFormSuccess> |
    ReturnType<typeof ContactUsPageActions.submitFormFail>
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ContactUsPageActions.submitForm),
      switchMap((action) => {
        this.globalService.loadingSubject.next(true);
        if (!!action.formData) {
          return this.apiService.contactusdetails(action.formData)
            .pipe(
              map(() => {
                this.globalService.loadingSubject.next(false);
                return ContactUsPageActions.submitFormSuccess({ statusCode: true });
              }),
              catchError((error) => {
                this.globalService.loadingSubject.next(false);
                return of(ContactUsPageActions.submitFormFail({ payload: tryNormalizeHttpError(error, this.logger) }));
              })
            );
        }
        else {
          this.globalService.loadingSubject.next(false);
          return null
        }
      })
    )
  );

}
